module.exports = __webpack_public_path__ + "img/section25.83d71298.png";